// extracted by mini-css-extract-plugin
export default {"main":"DetailMap_main__qCl8Y","box_map":"DetailMap_box_map__LETGr","flareAnimation":"DetailMap_flareAnimation__6ipEe","shine":"DetailMap_shine__ejEu0"};